import PropTypes from 'prop-types'

import { FormModal } from './FormModal'

/** Modal shell for the Quote / Work Order flows whose children carry their own form and buttons
 *  (Close Quote?, Delete Work Order?, Select insurance / client, ...).
 *
 *  CAR-4050: drawn through FormModal, so it has the standard navy header like every other pop-up:
 *    ┌────────────────────────────────────┐
 *    │ Title                            X │   ← standard navy header
 *    │  ┌──────────────────────────────┐  │
 *    │  │  ...children (form + CTA)... │  │  ← parent card (rounded border)
 *    │  └──────────────────────────────┘  │
 *    └────────────────────────────────────┘
 *
 *  The body scrolls when the children exceed `maxHeight`. Pass `bare` to render `children` directly without
 *  the inner bordered card, and `footer` (a FormModalFooter) for the standard buttons. `width` keeps its old w-[...] values; it now caps the width (narrow screens
 *  shrink to fit). Read-only users: FormModal disables the controls inside; the close button stays live. */
export const BrandedModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  width = 'w-[520px]',
  maxHeight = 'max-h-[90vh]',
  bare = false,
  footer
}) => (
  <FormModal
    open={open}
    onClose={onClose}
    title={title}
    subtitle={subtitle}
    width={width.replace(/^w-/, 'max-w-')}
    maxHeight={maxHeight}
    footer={footer}
  >
    {bare ? children : <div className='rounded-xl border border-[#D1D5D8] bg-white p-5'>{children}</div>}
  </FormModal>
)

BrandedModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  width: PropTypes.string,
  maxHeight: PropTypes.string,
  bare: PropTypes.bool,
  footer: PropTypes.node
}
